import React from 'react'
import {createUseStyles} from 'react-jss'

const useStyles = createUseStyles({
  dropdown: {
    'minWidth': '11em',
    'position': 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
    '& .show': {
      display: 'block !important',
    },
    '& .menu': {
      padding: 0,
      display: 'none',
      position: 'absolute',
      left: 0,
      top: '100%',
      zIndex: 10,
      right: 0,
      backgroundColor: 'white',
      textAlign: 'left',
    },
    '& .menu-item': {
      width: '100%',
      padding: '1em',
      listStyleType: 'none',
    },
    '& .menu-item:hover': {
      backgroundColor: '#F3F2F4',
      listStyleType: 'none',
      color: '#323232',
    },
  },
  gravName: {
    display: 'inline',
    marginTop: '0.75em',
    padding: '0 0.5vw',
    fontSize: '1.2em',
    marginRight: '10px',
    pointerEvents: 'none',
  },
  gravImg: {
    display: 'inline',
    verticalAlign: 'middle',
    marginRight: '5px',
    borderRadius: '50%',
    pointerEvents: 'none',
  },
})

interface User {
  uuid: string
  confirmed: boolean
  gravatarUrl: string
  given_name: string
}

interface IUserDropdown {
  user: User
  signOut: Function
}

const UserDropdown : React.FunctionComponent<IUserDropdown> = ({user, signOut}) => {
  const classes = useStyles()
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    const listener = (event) => {
      if (event.target.classList.contains(classes.dropdown)) {
        setShow(!show)
      } else {
        setShow(false)
      }
    }
    document.addEventListener('click', listener)
    return () => {
      document.removeEventListener('click', listener)
    }
  }, [])

  if (!user) {
    return null
  }

  return (
    <span className={classes.dropdown}>
      <img
        alt='User avatar'
        className={classes.gravImg}
        src={user.gravatarUrl}
        srcSet={`${user.gravatarUrl} 2x`}
        height={36}
        width={36}
      />
      <p className={classes.gravName}>{user.given_name}</p> <i aria-hidden='true' className='fas fa-caret-down' />

      <ul className={`menu ${show && 'show'}`}>
        <a href='/workspaces'><li className='menu-item'>Workspaces</li></a>
        <a href='/profile'><li className='menu-item'>Profile</li></a>
        <a onClick={signOut}><li className='menu-item sign-out'>Sign Out</li></a>
      </ul>
    </span>
  )
}

export default UserDropdown
